<div class="d-flex justify-content-center align-items-center">
    <nb-icon icon="fa-lock-open" *ngIf="isNew"></nb-icon>
    <nb-icon
        icon="fa-spinner"
        class="icon-warning"
        class="fa-spin"
        *ngIf="isSent"
    ></nb-icon>
    <nb-icon icon="fa-lock" class="icon-success" *ngIf="isArchived"></nb-icon>
    <nb-icon
        icon="fa-exclamation-triangle"
        class="icon-danger"
        *ngIf="isError"
    ></nb-icon>
</div>
